import React from 'react';
import { Sparkles } from 'lucide-react';
import { Tooltip } from 'components/atoms/Base/Logo/Tooltip';
import { useTrackClick } from 'hooks/useTrackClick';

export interface AnalystSidebarButtonProps {
	collapsed: boolean;
	active: boolean;
	onClick: () => void;
	fullWidth?: boolean;
}

const AnalystSidebarButton: React.FC<AnalystSidebarButtonProps> = ({
	collapsed,
	active,
	onClick,
	fullWidth = false,
}) => {
	const trackClick = useTrackClick();

	const handleClick = () => {
		onClick();
		trackClick('Analyst Clicked', 'analyst-sidebar-button');
	};

	const inner = (
		<button
			type="button"
			onClick={handleClick}
			className={`group relative flex items-center transition-all duration-200 ease-[cubic-bezier(0.4,0,0.2,1)] text-ui ${
				active
					? 'bg-secondary-background text-primary shadow-[inset_0_0_0_0.2px_theme(colors.tertiary-background)]'
					: 'text-primary-text hover:bg-tertiary-background'
			} ${
				collapsed
					? 'w-9 h-9 rounded-[40px] justify-center'
					: fullWidth
						? 'w-full h-9 px-2 rounded-[40px] justify-start'
						: 'w-[206px] h-9 px-2 rounded-[40px] justify-start'
			}`}
		>
			<div className="w-6 h-6 flex items-center justify-center shrink-0">
				<span className={`transition-colors duration-500 ${active ? 'text-primary' : 'text-primary-text'}`}>
					<Sparkles className="w-[22px] h-[22px]" strokeWidth={1.75} />
				</span>
			</div>
			{!collapsed && (
				<div className="overflow-hidden whitespace-nowrap max-w-[160px] opacity-100 ml-[10px]">
					<span className="text-ui">Analyst</span>
				</div>
			)}
		</button>
	);

	if (collapsed) {
		return (
			<Tooltip text="Analyst" position="right">
				{inner}
			</Tooltip>
		);
	}

	return inner;
};

export default AnalystSidebarButton;
